export * from './custom-http.service';
export * from './authentication.service';
export * from './local-storage.service';
export * from './event.service';
export * from './game.service';
export * from './profile.service';
export * from './game-group.service';
export * from './auth-guard.service';
export * from './mobile.service';
export * from './poker.service';



// WEBPACK FOOTER //
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/app/shared/services/index.ts